// extracted by mini-css-extract-plugin
module.exports = {"cardWrap":"style_cardWrap__36tWx","formWarp":"style_formWarp__hQAl0","forgotPw":"style_forgotPw__3XOwf","text":"style_text__2Ka8M"};